import { ColumnCell, ColumnHeader } from './Components';

export const StatusColumn = {
  key: 'status',
  header: () => <ColumnHeader className="w-32">Status</ColumnHeader>,
  cell: ({ campaign }) => <ColumnCell className="capitalize">{campaign.status}</ColumnCell>,
};
